import { useEffect } from 'react';

const useEmailObfuscation = () => {
  useEffect(() => {
    const handleEmailReveal = (event) => {
      const element = event.target;
      const email = element.getAttribute('data-email');
      const domain = element.getAttribute('data-domain');
      
      if (email && domain) {
        const fullEmail = `${email}@${domain}`;
        element.innerHTML = `<a href="mailto:${fullEmail}" class="text-yellow-500 hover:text-yellow-400 transition-colors">${fullEmail}</a>`;
        element.classList.remove('cursor-pointer');
        element.removeEventListener('click', handleEmailReveal);
      }
    };

    // Function to add listeners to all obfuscated emails
    const addEmailListeners = () => {
      const emailElements = document.querySelectorAll('.email-obfuscated');
      emailElements.forEach(element => {
        if (!element.hasAttribute('data-listener-added')) {
          element.addEventListener('click', handleEmailReveal);
          element.setAttribute('data-listener-added', 'true');
        }
      });
    };

    // Add listeners initially
    addEmailListeners();

    // Create observer to watch for DOM changes
    const observer = new MutationObserver(() => {
      addEmailListeners();
    });

    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Cleanup function
    return () => {
      observer.disconnect();
      const emailElements = document.querySelectorAll('.email-obfuscated');
      emailElements.forEach(element => {
        element.removeEventListener('click', handleEmailReveal);
        element.removeAttribute('data-listener-added');
      });
    };
  }, []);
};

export default useEmailObfuscation;